import React, { useState } from "react";
import { addOrderProductsById, getProducts } from "../../actions";
import { useDispatch, useSelector } from 'react-redux';
import ReusableMultiSelectDialog from "../../components/ReusableMultiSelectDialog";

const AddOrderProducts = ({
    orderItem,
    setClicked
}) => {
    const allProducts = useSelector((state) => state.product.allProducts)
    const [productIds, setProductIds] = useState([]);

    const dispatch = useDispatch()

    const handleSubmit = () => {
        const payload = {
            orderId: orderItem._id,
            productIds
        }
        dispatch(addOrderProductsById(payload))
        // setClicked(null)
    }
    return (
        <div className="renderOrderDetails__addOrderProduct">
            <ReusableMultiSelectDialog
                type="product"
                title="Добавить новые товар к этому заказу"
                description="Выберите нужные товары из списка, и к ним одну из категорию в списке ниже"
                data={allProducts}
                selectedValues={productIds}
                setSelectedValues={setProductIds}
                onSubmit={handleSubmit}
                fetchData={getProducts}
                buttonText="Добавить товары"
            />
        </div>
    );
};

export default AddOrderProducts;